import { BRAND, DEPARTMENTS, STORE_HOURS_SUMMARY } from "@neus/shared";
import { CONTENT, shown } from "./content";
import { contractorAdmin } from "./features";

export interface NavItem {
  label: string;
  to: string;
  children?: NavItem[];
}

/** The main menu, from the brand's site.json; "departments" lists the brand's menu departments. */
export const MAIN_NAV: NavItem[] = CONTENT.site.nav.filter(shown).map(({ label, to, children }) => {
  const links =
    children === "departments"
      ? DEPARTMENTS.filter((d) => d.inMenu).map((d) => ({ label: d.name, to: `/${d.slug}` }))
      : children?.filter(shown).map((c) => ({ label: c.label, to: c.to }));
  // No dropdown when every link in it is hidden.
  return { label, to, children: links?.length ? links : undefined };
});

/** The staff pages, for the header's Admin menu and the tabs on the pages themselves. */
export const STAFF_PAGES: (NavItem & { end?: boolean })[] = [
  { label: "Orders", to: "/admin/orders", end: true },
  { label: "Completed", to: "/admin/orders/completed" },
  ...(contractorAdmin ? [{ label: "Contractors", to: "/admin/contractors" }] : []),
];

/** `tel:` link for the brand's phone number. */
export const PHONE_HREF = `tel:+1${BRAND.phone.replace(/\D/g, "")}`;

/** From the one table of opening hours in shared, which also limits job-site delivery times. */
export const STORE_HOURS = STORE_HOURS_SUMMARY;
